// The draft store of the app, on the app's memory DB. Imported by the data
// worker (refreshData, updateData) and by the hooks: it imports neither React
// nor useData, so the worker can import it without a cycle.

import { db, refManager } from "../../db";
import { createDraftStore } from "./store";
import { registerDefaultScopeRoutes } from "./scopes";

export const draft = createDraftStore({ db, refManager });

registerDefaultScopeRoutes(draft);

export default draft;
